// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version
// MODFIED DATE : 05-09-2025

import PartnerDetailsActionTypes from './partner-details.types';

/** ***************** ADD BUSINESS PARTNER START *********************** */
export const addBusinessPartnerStart = (partnerData: any) => ({
	type: PartnerDetailsActionTypes.ADD_BUSINESS_PARTNER_START,
	payload: partnerData,
});

export const addBusinessPartnerSuccess = (successValue: any) => ({
	type: PartnerDetailsActionTypes.ADD_BUSINESS_PARTNER_SUCCESS,
	payload: successValue,
});

export const addBusinessPartnerFailure = (failureData: any) => ({
	type: PartnerDetailsActionTypes.ADD_BUSINESS_PARTNER_FAILURE,
	payload: failureData,
});

export const addBusinessPartnerResponseResetStart = () => ({
	type: PartnerDetailsActionTypes.ADD_BUSINESS_PARTNER_RESPONSE_RESET,
});

export const addBusinessPartnerResponseChanged = () => ({
	type: PartnerDetailsActionTypes.ADD_BUSINESS_PARTNER_RESPONSE_CHANGED,
});
/** ***************** ADD BUSINESS PARTNER END *********************** */

/** ***************** UPDATE BUSINESS PARTNER START *********************** */
export const updateBusinessPartnerStart = (updateData: any) => ({
	type: PartnerDetailsActionTypes.UPDATE_BUSINESS_PARTNER_START,
	payload: updateData,
});

export const updateBusinessPartnerSuccess = (successData: any) => ({
	type: PartnerDetailsActionTypes.UPDATE_BUSINESS_PARTNER_SUCCESS,
	payload: successData,
});

export const updateBusinessPartnerFailure = (failureData: any) => ({
	type: PartnerDetailsActionTypes.UPDATE_BUSINESS_PARTNER_FAILURE,
	payload: failureData,
});

export const updateBusinessPartnerResponseResetStart = () => ({
	type: PartnerDetailsActionTypes.UPDATE_BUSINESS_PARTNER_RESPONSE_RESET,
});

export const updateBusinessPartnerResponseChanged = () => ({
	type: PartnerDetailsActionTypes.UPDATE_BUSINESS_PARTNER_RESPONSE_CHANGED,
});
/** ***************** UPDATE BUSINESS PARTNER END *********************** */

/** ***************** FETCH BUSINESS PARTNER START *********************** */
export const fetchBusinessPartnerStart = (fetchData: any) => ({
	type: PartnerDetailsActionTypes.FETCH_BUSINESS_PARTNER_START,
	payload: fetchData,
});

export const fetchBusinessPartnerSuccess = (successData: any) => ({
	type: PartnerDetailsActionTypes.FETCH_BUSINESS_PARTNER_SUCCESS,
	payload: successData,
});

export const fetchBusinessPartnerFailure = (failureData: any) => ({
	type: PartnerDetailsActionTypes.FETCH_BUSINESS_PARTNER_FAILURE,
	payload: failureData,
});

export const fetchBusinessPartnerResponseResetStart = () => ({
	type: PartnerDetailsActionTypes.FETCH_BUSINESS_PARTNER_RESPONSE_RESET,
});

export const fetchBusinessPartnerResponseChanged = () => ({
	type: PartnerDetailsActionTypes.FETCH_BUSINESS_PARTNER_RESPONSE_CHANGED,
});
/** ***************** FETCH BUSINESS PARTNER END *********************** */

/** ***************** DELETE BUSINESS PARTNER START *********************** */
export const deleteBusinessPartnerStart = (fetchData: any) => ({
	type: PartnerDetailsActionTypes.DELETE_BUSINESS_PARTNER_START,
	payload: fetchData,
});

export const deleteBusinessPartnerSuccess = (successData: any) => ({
	type: PartnerDetailsActionTypes.DELETE_BUSINESS_PARTNER_SUCCESS,
	payload: successData,
});

export const deleteBusinessPartnerFailure = (failureData: any) => ({
	type: PartnerDetailsActionTypes.DELETE_BUSINESS_PARTNER_FAILURE,
	payload: failureData,
});

export const deleteBusinessPartnerResponseResetStart = () => ({
	type: PartnerDetailsActionTypes.DELETE_BUSINESS_PARTNER_RESPONSE_RESET,
});

export const deleteBusinessPartnerResponseChanged = () => ({
	type: PartnerDetailsActionTypes.DELETE_BUSINESS_PARTNER_RESPONSE_CHANGED,
});
/** ***************** DELETE BUSINESS PARTNER END *********************** */
